import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11140cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics-menu" }
const _hoisted_2 = { class: "statistics-menu-header" }
const _hoisted_3 = { class: "has-text-contents-title has-text-title" }
const _hoisted_4 = { class: "statistics-menu-body has-background-contents" }
const _hoisted_5 = { class: "date-container" }
const _hoisted_6 = { class: "date-input-container" }
const _hoisted_7 = { class: "date-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ～ ", -1))
const _hoisted_9 = { class: "date-input" }
const _hoisted_10 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("header.statisticsDownload")), 1)
    ]),
    _createElementVNode("body", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('label.outputPeriod')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_Datepicker, {
              class: "date-picker from-date",
              modelValue: _ctx.fromDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event)),
              startingView: "month",
              minimumView: "month",
              "input-format": "yyyy-MM",
              locale: _ctx.ja,
              clearable: true,
              style: _normalizeStyle(_ctx.dateCssConfig)
            }, null, 8, ["modelValue", "locale", "style"])
          ]),
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_Datepicker, {
              class: "date-picker to-date",
              modelValue: _ctx.toDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toDate) = $event)),
              startingView: "month",
              minimumView: "month",
              "input-format": "yyyy-MM",
              locale: _ctx.ja,
              clearable: true,
              style: _normalizeStyle(_ctx.dateCssConfig)
            }, null, 8, ["modelValue", "locale", "style"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_AppButton, {
            id: "view-statistics",
            styled: "is-accent",
            disabled: !_ctx.fromDate || !_ctx.toDate,
            onClick: _ctx.downloadStatisticsTSV,
            onKeydown: _withKeys(_withModifiers(_ctx.downloadStatisticsTSV, ["prevent"]), ["space","enter"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("header.statisticsDownload")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick", "onKeydown"])
        ])
      ])
    ])
  ]))
}